import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { usePrivacy } from '../contexts/PrivacyContext';

ChartJS.register(ArcElement, Tooltip, Legend);

interface AreaDistributionChartProps {
  data: Array<{
    area_name: string;
    current_value_eur: number;
    current_percentage: number;
  }>;
}

const AreaDistributionChart: React.FC<AreaDistributionChartProps> = ({ data }) => {
  // Verificar se estamos no dashboard público
  const isPublicDashboard = window.location.pathname.includes('/public/');
  
  // Sempre chamar o hook do contexto de privacidade
  const { valuesHidden } = usePrivacy();
  
  // No dashboard público, sempre ocultar valores
  const shouldHideValues = isPublicDashboard || valuesHidden;
  const colors = [
    'rgb(59, 130, 246)',   // Blue
    'rgb(16, 185, 129)',   // Green
    'rgb(245, 158, 11)',   // Yellow
    'rgb(239, 68, 68)',    // Red
    'rgb(139, 92, 246)',   // Purple
    'rgb(236, 72, 153)',   // Pink
  ];

  const chartData = {
    labels: data.map(item => item.area_name),
    datasets: [
      {
        data: data.map(item => item.current_value_eur),
        backgroundColor: colors.slice(0, data.length),
        borderColor: colors.slice(0, data.length).map(color => color.replace('rgb', 'rgba').replace(')', ', 0.8)')),
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Remover legenda completamente
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            const value = context.parsed;
            const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            if (shouldHideValues) {
              return `${context.label}: *** (${percentage}%)`;
            }
            return `${context.label}: €${value.toLocaleString('pt-PT', { minimumFractionDigits: 2 })} (${percentage}%)`;
          }
        }
      }
    },
    cutout: '50%',
  };

  return (
    <div className="h-80">
      <Doughnut data={chartData} options={options} />
    </div>
  );
};

export default AreaDistributionChart;